import { HttpClient } from '@angular/common/http';
import { CacheService } from '../cache';
import { ResourceService } from './resource';
import { IVideo, Video } from '../../models/media';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VideoService extends ResourceService<Video> {
/**
   * @constructor 
   * Creates an instance of the VideoService 
   *
   * @param {HttpClient} http Injected instance of HttpClient
   * @param {CacheService} cache Injected instance of CacheService
 */
  constructor(
    protected http: HttpClient,
    protected cache: CacheService
  ) {
    super(http, cache, 'videos');
  }

   /**
  * Sets a parentId on the VideoService instance, to effectively mutate the endpoint
  * and act as a sub/child resource instance
  * 
  * @param {string} parentId A unique identifier for the parent resource
  * @param {string} roomId Optional flag to specify  roomId
  * @returns {this} Returns an instance of the class so the method can be chained.
  */
  public setParent(propertyId: string, roomId?: string) {
    let endpoint = `properties/${propertyId}`;
    if (roomId !== undefined) {
      endpoint += `/rooms/${roomId}`;
    }
    this.endpoint = `${endpoint}/videos`;
    return this;
  }

}
